import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CompanyContextService } from '../company-context/company-context.service';
import { environment } from '../../../environments/environment';

/**
 * Company switcher interceptor (P0).
 *
 * Kad je ADMIN/SUBADMIN "ušao" u firmu preko switchera, svi dashboard pozivi
 * prema našem API-ju dobiju `?companyId=<id>` pa postojeći ekrani (kandidati,
 * oglasi, kalendar, poruke, burza) rade nad tom firmom. Backend bez parametra
 * fallback-a na firmu iz tokena.
 *
 * Preskačemo:
 *  - tuđe domene (nikad ne curi naš kontekst van API-ja),
 *  - `/public/*` (anonimne rute),
 *  - `/auth/*` (token-issuing rute),
 *  - `/admin/*` (admin resursi su globalni — firme, banka pitanja, usluge,
 *    leadovi; gdje admin ruta treba firmu, komponenta ju šalje eksplicitno),
 *  - pozive koji `companyId` već nose (caller je eksplicitan → ne diramo).
 */
export const companyContextInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiBaseUrl)) return next(req);
  if (req.url.includes('/public/')) return next(req);
  if (req.url.includes('/auth/')) return next(req);
  if (req.url.includes('/admin/')) return next(req);
  if (req.params.has('companyId')) return next(req);

  const companyId = inject(CompanyContextService).companyId();
  if (companyId === null) return next(req);

  return next(req.clone({ params: req.params.set('companyId', String(companyId)) }));
};
